import type { PaymentSettings } from '../types';
import CODIcon from '../components/icons/CODIcon';
import QRIcon from '../components/icons/QRIcon';
import BankTransferIcon from '../components/icons/BankTransferIcon';
import { QrisLogo } from '../components/icons/paymentLogos';

export const SHIPPING_LABELS: Record<string, string> = {
  regular: 'Regular',
  free: 'Gratis Ongkir',
};

export const PAYMENT_CONFIG: Record<keyof PaymentSettings, { label: string; icon: React.FC<{ className?: string }> }> = {
  cod: { label: 'Bayar di Tempat (COD)', icon: CODIcon },
  codJawaBali: { label: 'COD Jawa-Bali', icon: CODIcon },
  codLuarJawaBali: { label: 'COD Luar Jawa-Bali', icon: CODIcon },
  qris: { label: 'QRIS', icon: QrisLogo },
  bankTransfer: { label: 'Transfer Bank', icon: BankTransferIcon },
  duitku: { label: 'Pembayaran Otomatis (Duitku)', icon: QRIcon },
};
